module.exports = __webpack_public_path__ + "img/bg_selection2.edadae9e.png";